import { useQuery } from "@tanstack/react-query";
import { getTaskFiles } from "@coworker/apprestructured/src/task-management/services/tasks.service";
import { getTaskFilesQueryKey } from "@coworker/apprestructured/src/task-management/services/queryKeyHelper";
import { createPreviousOnNullPlaceholderDataFn } from "@coworker/apprestructured/src/task-management/services/queryHelper";
import { SignedUpload } from "@coworker/apprestructured/src/task-management/types/Upload";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";

export function useTaskFiles(taskId: string | null) {
  return useQuery({
    queryKey: getTaskFilesQueryKey(taskId),
    queryFn: () => getTaskFiles(taskId!),
    enabled: taskId !== null,
    placeholderData:
      createPreviousOnNullPlaceholderDataFn<SignedUpload[]>(taskId),
    staleTime: INTERVAL.WEEK,
  });
}
